/**
 * PollSkeleton
 *
 * A skeleton loading state for the Poll component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface PollSkeletonProps {
  className?: string
  optionCount?: number
}

export const PollSkeleton: React.FC<PollSkeletonProps> = ({ className, optionCount = 4 }) => {
  return (
    <div
      className={cn(
        'border-border bg-card my-4 flex animate-pulse flex-col overflow-hidden rounded-lg border shadow-sm transition-all',
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center border-b p-3">
        <div className="flex items-center gap-2">
          <div className="size-4 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-12 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>

      {/* Poll content */}
      <div className="p-4">
        {/* Question */}
        <div className="mb-4">
          <div className="h-5 w-3/4 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>

        {/* Options */}
        <div className="space-y-3">
          {[...Array(optionCount)].map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="size-5 rounded-full bg-gray-200 dark:bg-gray-700"></div>
              <div className="flex-1">
                <div className="h-8 w-full rounded-md bg-gray-200 dark:bg-gray-700"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Vote count */}
        <div className="mt-4 flex justify-between border-t pt-3">
          <div className="h-4 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-16 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>
    </div>
  )
}
